import React, { Component } from 'react';
import { notification, Table, Modal } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import dashboardService from 'services/dashboard.service';
import { AuthContext } from 'context/AuthContext';
import { formatMoney, formatDateForClient } from 'helpers/utils';
import { NavLink } from 'react-router-dom';
import 'antd/dist/reset.css';
import dayjs from 'dayjs';

class InvoiceInformation extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      loading: false,
      currentMerch: context?.selectedMerch,
      startDate: formatDateForClient(dayjs().subtract(2, 'years')),
      endDate: formatDateForClient(),
      modalVisible: false,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Fatura No</div>,
          dataIndex: 'InvoiceNumber',
          key: 'InvoiceNumber',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceNumber ? row.InvoiceNumber : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tutarı</div>,
          dataIndex: 'InvoiceAmount',
          key: 'InvoiceAmount',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceAmount ? formatMoney(row.InvoiceAmount) : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tarihi</div>,
          dataIndex: 'InvoiceDate',
          key: 'InvoiceDate',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceDate ? dayjs(row.InvoiceDate).format('DD.MM.YYYY') : ''}
            </span>
          ),
        },
      ],
      partialColumns: [
        {
          title: (
            <div className="table-title-calibri-bold-12">
              Fatura Durumu / Takip No / Fatura Kes Slip Tarihi
            </div>
          ),
          dataIndex: 'Invoice',
          key: 'Invoice',
          width: 340,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.AgreementStatus ? row.AgreementStatus : ''} - {row.TakipNo ? row.TakipNo : ''} -{' '}
              {row.FaturaKesSlipTarihi
                ? dayjs(row.FaturaKesSlipTarihi).format('DD.MM.YYYY hh:mm:ss')
                : ''}
            </span>
          ),
        },
        {
          title: (
            <div className="table-title-calibri-bold-12">Şube - Merkez / Şube No / Şube Adı</div>
          ),
          dataIndex: 'Branch',
          key: 'Branch',
          width: 260,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.SubeOrMerkez ? row.SubeOrMerkez : ''} - {row.BranchId ? row.BranchId : ''} -{' '}
              {row.BranchName ? row.BranchName : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tarihi / Fatura No</div>,
          dataIndex: 'InvoiceDateAndNo',
          key: 'InvoiceDateAndNo',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceDate ? dayjs(row.InvoiceDate).format('DD.MM.YYYY') : ''} -{' '}
              {row.InvoiceNumber ? row.InvoiceNumber : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tutarı</div>,
          dataIndex: 'InvoiceAmount',
          key: 'InvoiceAmount',
          width: 130,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceAmount ? formatMoney(row.InvoiceAmount) : ''} TL
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Hakediş Tutarı</div>,
          dataIndex: 'HakedisAmount',
          key: 'HakedisAmount',
          width: 130,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.HakedisAmount ? formatMoney(row.HakedisAmount) : ''} TL
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tarihi / Ödeme Durumu</div>,
          dataIndex: 'PaymentDate',
          key: 'PaymentDate',
          width: 230,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.PaymentDate ? dayjs(row.PaymentDate).format('DD.MM.YYYY') : ''} -{' '}
              {row.PaymentAmount ? formatMoney(row.PaymentAmount) : ''} TL
            </span>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getInvoices();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getInvoices();
    }
  }

  getInvoices = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      const { currentMerch } = this.state;
      if (currentMerch?.number) {
        try {
          const { payload } = await dashboardService.getDashboardMyInvoices(currentMerch?.number);
          this.setState({ data: payload, loading: false });
        } catch (error) {
          notification.error({
            message: 'İşlem Başarısız!',
            description: error,
          });
          this.setState({ loading: false });
        }
      }
    });
  };

  handleCloseForm = () => {
    this.setState({ modalVisible: false, partialReports: [] });
  };

  render() {
    const { columns, data, loading, partialColumns, partialReports, modalVisible } = this.state;

    return (
      <>
        <PageContainer
          title="Fatura Bilgileri"
          footer={[
            <div
              key="footer-link"
              style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
            >
              <NavLink to="/odemeler-ve-faturalar/tarafima-kesilen-faturalar">
                <span style={{ color: 'blue', fontSize: 15 }}>Tarafımdan Kesilen Faturalar </span>
              </NavLink>
            </div>,
          ]}
        >
          <Table
            loading={loading}
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey={(record, index) => index}
          />
        </PageContainer>

        <Modal
          width={1400}
          open={modalVisible}
          footer={false}
          title="Fatura Bilgileri"
          onCancel={this.handleCloseForm}
          destroyOnClose
        >
          <Table
            loading={loading}
            dataSource={partialReports}
            columns={partialColumns}
            pagination
            rowKey={(record, index) => index}
          />
        </Modal>
      </>
    );
  }
}

InvoiceInformation.contextType = AuthContext;
export default InvoiceInformation;
